<template>
	<div class="row mx-0" style="padding-left: 1.5rem; position: relative;">

		<!-- delete item button -->
		<button :title="(item.structured == 'optional' ? 'Deactivate Optional Field' : 'Remove Field' )" :class="{ 'd-none': ( augment && augmenting !== 'force' ) || disabled || !source || item.structured == 'required' }" class="btn btn-danger mt-1" @click.prevent="removeThisItem" style="width: 40px; position: absolute; right: -50px; top: 0;"><i class="fas fa-times"></i></button>
		<button title="Activate Optional Field" :class="{ 'd-none': !canActivateField( ) }" class="btn btn-success mt-1" @click.prevent="activateThisItem" style="width: 40px; position: absolute; right: -50px; top: 0;"><i class="fas fa-plus"></i></button>
		<button :title="`Required Field\nCannot Remove`" disabled :class="{ 'd-none': item.structured !== 'required' }" class="btn btn-light mt-1 text-muted" style="width: 40px; position: absolute; right: -50px; top: 0;"><i class="fas fa-asterisk"></i></button>

		<button :title="'Unaugmented Field\nClick to unlock for editing.'" :class="{ 'd-none': !isAugState( false ) }" class="btn btn-secondary mt-1" @click.prevent="cycleAugmentingMode" style="width: 40px; position: absolute; right: -50px; top: 0;"><i class="fas fa-lock"></i></button>
		<button :title="'Augmented: Replaced\nClick to hide field.'" :class="{ 'd-none': !isAugState( true ) }" class="btn btn-success mt-1" @click.prevent="cycleAugmentingMode" style="width: 40px; position: absolute; right: -50px; top: 0;"><i class="fas fa-lock-open"></i></button>
		<button :title="'Augmented: Hidden\nClick to restore original field.'" :class="{ 'd-none': !isAugState( 'hide' ) }" class="btn btn-warning mt-1" @click.prevent="cycleAugmentingMode" style="width: 40px; position: absolute; right: -50px; top: 0;"><i class="fas fa-eye-slash"></i></button>

		<!-- object field name entry (object only) -->
		<div v-if="item.hasOwnProperty('fieldname')" class="col-4 p-0 text-nowrap pr-2" style="min-width: 200px; margin-left: -1.5rem !important;">
			<input :disabled="item.structured || isDisabled || augmenting === true" :id="htmlId" type="text" class="form-control mt-1" v-model="item.fieldname" placeholder="[Field Name]" style="display: inline !important;">
			<label class="col-form-label font-weight-bold mt-1" style="display: inline !important;">:</label>
		</div>

		<!-- list item index (arrays only) -->
		<div v-else class="col-0 p-0 pr-1 text-right mt-1" style="width: 3rem; !important; margin-left: -3rem !important;">
			<label class="col-form-label font-weight-bold">{{index}}</label>
		</div>

		<!-- standard valuetype selector -->
		<div v-if="augmenting !== 'hide'" class="col-2 pl-1 pr-0" style="min-width: 140px; width: 100%;">
			<select :disabled="isDisabled || noTypeChoices" :id="( !item.hasOwnProperty('fieldname') ? htmlId : undefined )" class="form-control mt-1 pr-0" v-model="type">
				<option v-if="myAllowedTypes['string.short']" value="string.short">Text String</option>
				<option v-if="myAllowedTypes['string.block']" value="string.block">Text Block</option>
				<option v-if="myAllowedTypes['string.html']" value="string.html">Rich Text (HTML)</option>
				<option v-if="myAllowedTypes['number']" value="number">Number</option>
				<option v-if="myAllowedTypes['date']" value="date">Date</option>
				<option v-if="myAllowedTypes['boolean']" value="boolean">Switch (on/off)</option>
				<option v-if="myAllowedTypes['reference']" value="reference">Reference</option>
				<optgroup v-if="myAllowedTypes['image'] || myAllowedTypes['file_any']" label="Binary (File)">
					<option v-if="myAllowedTypes['image']" value="image">Image</option>
					<option v-if="myAllowedTypes['file_any']" value="file_any">Any File</option>
				</optgroup>
				<optgroup v-if="myAllowedTypes['array'] || myAllowedTypes['object']" label="Structure">
					<option v-if="myAllowedTypes['array']" value="array">List (Array)</option>
					<option v-if="myAllowedTypes['object']" value="object">Object</option>
				</optgroup>
				<optgroup v-if="myAllowedTypes['null']" label="Advanced">
					<option v-if="myAllowedTypes['null']" value="null">Empty (null)</option>
				</optgroup>
			</select>
		</div>

		<div v-if="!isDisabled && type === 'array'" class="col-auto pl-1 pr-0">
			<button @click.prevent="addSubItem({})" class="btn btn-info mt-1"><i class="fas fa-plus"></i> Add Value to List</button>
		</div>

		<div v-if="!isDisabled && type === 'object' && !mySchemaItem.value" class="col-auto pl-1 pr-0">
			<button @click.prevent="addSubItem({})" class="btn btn-info mt-1"><i class="fas fa-plus"></i> Add Field to Object</button>
		</div>

		<div v-if="type === 'reference'" class="col pl-1 pr-0">
			<select :disabled="isDisabled" v-model="referenceStyle" class="form-control mt-1 mr-1 pr-0">
				<option value="select">Pick from Object List</option>
				<option value="manual">Enter ID Manually</option>
				<option value="search">Search (Upcoming)</option>
			</select>
		</div>

		<!-- value entry controls -->
		<div v-if="augmenting==='hide'" class="pl-1 pr-0" style="min-width: 200px;">
			<label class="col-form-label mt-1 pl-1"><em class="text-danger text-nowrap"><strong>(Field Hidden)</strong></em></label>
		</div>

		<div v-else-if="item.inactive===true && augmenting !== 'force'" class="pl-1 pr-0" style="min-width: 200px;">
			<label class="col-form-label mt-1 pl-1"><em class="text-muted text-nowrap">(Unused Optional Field)</em></label>
		</div>

		<div v-else class="pl-1 pr-0" :class="getValueTypeClass(type)" style="min-width: 200px;">

			<!-- compact types -->
			<input :disabled="isDisabled" v-if="type === 'string.short'" :pattern="validation.formFieldRegex" :minlength="validation.formFieldMinLength" :maxlength="validation.formFieldMaxLength" v-model="value.string" type="text" class="form-control mt-1" placeholder="[Text String Value]">
			<input :disabled="isDisabled" v-if="type === 'number'" v-model.number="value.number" type="number" class="form-control mt-1" placeholder="[Number Value]" :min="validation.formFieldMin" :max="validation.formFieldMax" :step="validation.formFieldStep">
			<input :disabled="isDisabled" v-if="type === 'date'" :value="getDateLocalISOString(value.date)" @input="$set( value, 'date', new Date( $event.target.value ) )" type="datetime-local" step="1" class="form-control mt-1">
			
			<input-checkbox v-if="type === 'boolean'" class="d-inline-block mt-1" v-model="value.boolean" :label="( value.boolean ? 'On/Yes/True/Enabled' : 'Off/No/False/Disabled' )" :disabled="isDisabled" />

			<label v-if="type === 'null'" class="col-form-label mt-1 pl-1"><em class="text-muted">(Empty/Null Placeholder)</em></label>

			<object-editor-reference :disabled="isDisabled" v-if="type === 'reference'" v-model="value.reference" :reference-style="referenceStyle" :validation="validation" />
			
			<!-- non-compact types -->
			<textarea :disabled="isDisabled" v-if="type === 'string.block'" v-model="value.string" rows="2" class="form-control mt-1" placeholder="[Text Block Value]"></textarea>
			<textarea :disabled="isDisabled" v-if="type === 'string.html'" v-model="value.string" rows="2" class="form-control mt-1" placeholder="[Rich Text Entry]"></textarea>

			<!-- Handle objects and arrays -->
			<template v-if="type === 'object'">
				<object-editor-schema :disabled="disabled" :augment="augment && !augmenting" v-if="getSchemaItem( ) !== undefined" :item="getSchemaItem( )" :schemas="schemas" :allowed-schemas="allowedSchemas"></object-editor-schema>
				<object-editor-id-nested :disabled="disabled" :augment="augment && !augmenting" :item="getIdItem( )" :schemas="schemas" :allowed-schemas="allowedSchemas"></object-editor-id-nested>
			</template>
			<object-editor-item :disabled="disabled" :augment="augment && !augmenting" v-for="( subItem, subIndex ) in subItems" :key="subItem._htmlId" :schemas="schemas" :item="subItem" :index="subIndex" :source="subItems"></object-editor-item>
			
		</div>
	</div>
</template>

<script>
// import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import ObjectEditorReference from "@/components/utilities/ObjectEditorReference";
import ObjectEditorItem from "@/components/utilities/ObjectEditorItem";
import InputCheckbox from "@/components/utilities/InputCheckbox";
import { randomString } from '../../util';
import Validation from "@/Validation.class";

import Vue from 'vue';

export default {
	name: "object-editor-item",
	props: {
		item : { type : Object, required : true },
		index : { type : Number, required : false },
		source : { type : Array, required : false },
		restrictedTypes : { type : Object, required : false, default : () => ({}) },	// { "<type>" : false, ... }
		disabled : { type : Boolean },	// Disable this item RECURSIVELY
		augment : { type : Boolean },
		schemas : { type: Object, default: function( ) { return { raw : [], compiled : {} }; } },
		allowedSchemas : { type: Array, required : false },
		//validators : { type : Array, required : false, default : () => ([]) }
		// TODO: Implement for structured fields, including in combination with augmentation :)
		// structured : { type : String, required : false }	// IF this is part of a predetermined structure, provide "optional" or "required".
	},
	data() {
		return {
			value : {
				// string : "",
				// reference : { $source = "" },
				// object_fields : [],
				// array_values : []
			},
			type : '',
			referenceStyle : "select",
			augmenting : false,	// Possible values:
			                    // false: We are NOT augmenting the PRE-EXISTING (on source) version of this field
			                    // true: We are ALTERING a PRE-EXISTING version of this field
								// "hide": We are HIDING a PRE-EXISTING version of this field
								// "force": We are ADDING a NEW field that does not exist in the source object
			validation : null
		};
	},
	components: {
		InputCheckbox,
		ObjectEditorItem,
		ObjectEditorReference,
		ObjectEditorSchema : () => import( "@/components/utilities/ObjectEditorSchema" ),
		ObjectEditorIdNested : () => import( "@/components/utilities/ObjectEditorIdNested" )
	},
	watch: {
		augmenting( newVal, oldVal )
		{
			if( newVal !== oldVal && typeof newVal === 'boolean' )
			{
				if( newVal === false )
				{
					this.$delete( this.item, 'aug' );
					this.type = this.item.type;
					this.setCachedValue( false );
					if( !this.type )
						console.warn( "Augmentation for this item has been turned off, yet there is no [type] defined on the source item.. This should never happen." );
				}

				if( this.type === 'object' )
					return this.$set( this.value, 'object_fields', ( newVal ? [] : this.item.fields || [] ) );
				else if( this.type === 'array' )
					return this.$set( this.value, 'array_values', ( newVal ? [] : this.item.values || [] ) );
			}
			this.updateItemValue( );
		},
		'item.$schema.type': function( newVal, oldVal )
		{
			console.log( "!SCHEMA [type] CHANGED:", newVal );
		},
		'item.$schema.value': function( newVal, oldVal )
		{
			console.log( "!SCHEMA [value] CHANGED:", newVal );
			const type = ( this.mySchemaItem.type || 'none' );
			const purgeFields = ( !oldVal && newVal ? true : false );
			this.updateSchemaFields( type, newVal, purgeFields );
		},
		'item.$schema.aug.value': function( newVal, oldVal )
		{
			console.log( "!SCHEMA [aug.value] CHANGED:", newVal );
			if( typeof newVal === 'undefined' )
				newVal = this.mySchemaItem.value;
			const type = ( this.mySchemaItem.type || 'none' );
			this.updateSchemaFields( type, newVal );
		},
		'item.type': function( newVal, oldVal )
		{
			this.updateItemValue( );
		},
		'item.aug.type': function( newVal, oldVal )
		{
			this.updateItemValue( );
		},
		type( newVal, oldVal )
		{
			this.$set( this.activeItem, 'type', newVal );
			if( this.item.inactive === true && this.item.type !== newVal )
				this.$set( this.item, 'type', newVal );
			this.updateItemValue( );
		},
		value: {
			deep: true,
			handler( newVal, oldVal )
			{
				this.updateItemValue( );
			}
		},
		'item.validators':
		{
			deep : true,
			handler : function( newVal, oldVal ) {
				//console.log( "NEW Validators:", JSON.stringify( newVal ) );
				this.validation.updateValidators( { validators : newVal } );
			}
		},
	},
	computed:
	{
		noTypeChoices( )
		{
			return Object.keys( this.myAllowedTypes ).length <= 1;
		},
		myAllowedTypes( )
		{
			const restrict = this.restrictedTypes;

			const allowNull = ( !this.item.hasOwnProperty( 'allownull' ) || this.item.allownull === true );

			let types = {
				'string.short' : restrict.string !== false && restrict['string.short'] !== false,
				'string.block' : restrict.string !== false && restrict['string.block'] !== false,
				'number' : restrict.number !== false,
				'boolean' : restrict.boolean !== false,
				'date' : restrict.date !== false,
				'object' : restrict.object !== false,
				'array' : restrict.array !== false,
				'image' : restrict.image !== false,
				'file_any' : restrict.file_any !== false,
				'reference' : restrict.reference !== false,
				'null' : restrict.null !== false && allowNull
			}
			
			if( this.valuetypeLocked )
			{
				let pickList = [ ];
				if( this.itemType.startsWith( 'string' ) )
					pickList.push( 'string.short', 'string.block' );
				else
					pickList.push( this.itemType );
				if( allowNull )
					pickList.push( 'null' );
				types = _.pick( types, pickList );
			}

			return types;
		},
		htmlId( )
		{
			return this.item._htmlId;
		},
		// Is this item structured, optional AND inactive?
		fieldOptionalInactive( )
		{
			return this.item.structured == 'optional' && this.item.inactive === true;
		},
		// If THIS ITEM is an object, and it has a schema, return the schema structure; otherwise, return empty structure {}.
		mySchemaItem( )
		{
			return ( this.itemType === 'object' ? this.item.$schema || { } : { } );
		},
		augItem( )
		{
			if( !this.item.hasOwnProperty( 'aug' ) )
				this.$set( this.item, 'aug', { type : this.item.type } );
			if( !this.item.aug.hasOwnProperty( 'type' ) )
				this.$set( this.item.aug, 'type', this.item.type )
			
			return this.item.aug;
		},
		activeItem( )
		{
			if( this.augment && ( this.augmenting === true || this.augmenting === 'force' ) )
				return this.augItem;	// This is a computed property getter.
			return this.item;
		},
		itemType( )
		{
			return this.activeItem.type;
			// if( this.augment )
			// 	return this.augItem.type;
			// return this.item.type;
		},
		valuetypeLocked( )
		{
			return !!this.item.valuetypelocked;
		},
		isDisabled( )
		{
			return this.disabled || ( !this.augment && this.item.inactive ) || ( this.augment && this.augmenting !== true && this.augmenting !== 'force' );
		},
		subObjectFields( )
		{
			if( !this.value.hasOwnProperty( 'object_fields' ) )
				this.$set( this.value, 'object_fields', [] );
			return this.value.object_fields;
		},
		subArrayValues( )
		{
			if( !this.value.hasOwnProperty( 'array_values' ) )
				this.$set( this.value, 'array_values', [] );
			return this.value.array_values;
		},
		subItems( )
		{
			if( this.type === 'object' )
				return this.subObjectFields;
			else if( this.type === 'array' )
				return this.subArrayValues;
			return [];	// Enumerable "nothing", for condition-less usage in templates.
		}
	},
	created( )
	{
		//console.log( "ITEM:", JSON.stringify( this.item, null, 2 ) );

		// Set initial [augmenting] value.
		this.augmenting = false;
		if( this.augment && this.item.aug && typeof this.item.aug === 'object' )
		{
			if( this.item.aug.remove === true )
				this.augmenting = 'hide';
			else if( this.item.type === 'new' )
				this.augmenting = "force";	// This just means that this augmentation is a brand new field NOT on the source data.
			else
				this.augmenting = true;
		}

		this.validation = new Validation( { validators : this.item.validators } );

		// Set the initial appropriate internal cache value and type.
		this.setCachedValue( );
	},
	mounted( )
	{
		const schema = this.mySchemaItem;
		if( schema.type && schema.value )
			this.updateSchemaFields( schema.type, ( schema.aug && schema.aug.value ? schema.aug.value : schema.value ) );
		this.validation.updateValidators( { validators : this.item.validators } );	// Just in case.
	},
	methods:
	{
		canActivateField( )
		{
			if( this.augmenting === 'force' || this.disabled /* || !this.source */ )	// !this.source ??
				return false;
			
			return this.fieldOptionalInactive;
		},
		isAugState( type )
		{
			if( typeof type === 'undefined' )
				throw TypeError( `Must provide a [type] to check if we're in that aug state (true, false or 'hide')`);
			
			if( !this.augment || this.disabled || this.item.inactive || ( this.item.structured === 'optional' && typeof this.item.value === 'undefined' ) )
				return false;

			return this.augmenting === type;
		},
		updateSchemaFields( schemaType, schemaName, purgeFields = false )
		{
			if( !schemaType || schemaType === 'none' )
				return console.log( "ABORTING SCHEMA UPDATE" );	// NO Schema.
			else if( !schemaType.startsWith( "string" ) && schemaType !== 'local' )
				return alert( `Schema type [${schemaType}] not supported` );
			
			const item = this.activeItem;

			if( item.type !== 'object' || !Array.isArray( item.fields ) )
				return console.log( "No update to schema fields; not an object!" );

			// WARNING: This is only OK when not augmenting; right now, there's no issue, because we don't
			//	allow changing to a different schema in aug mode; only extending to a more specific derived one.
			if( !schemaName || purgeFields )
			{
				for( let i=item.fields.length-1; i >= 0; i-- )
					this.$delete( item.fields, i );
				if( !schemaName )
					return;
			}

			let schema;
			try {
				schema = this.schemas.compiled[schemaName];
				if( !schema )
					throw new Error( "No schema" );
			} catch( err ) { return console.log( `Could not retrieve schema [${schemaName}] during schema fields update.` ); }

			let remainingFieldNames = { };
			for( let i=item.fields.length-1; i >= 0; i-- )
			{
				const field = item.fields[i];
				const isRemoveInvalidField = ( field.aug && field.aug.remove && field.aug.lock );
				if( ( !schema.fieldsLookup[field.fieldname] && !isRemoveInvalidField ) || ( schema.fieldsLookup[field.fieldname] && isRemoveInvalidField ) )
					this.$delete( item.fields, i );
				else
					remainingFieldNames[field.fieldname] = field;
			}
			for( let f in schema.fieldsLookup )
			{
				const field = schema.fieldsLookup[f];
				if( field.parent )
					continue;
				const newType = ( field.valuetype === 'string' ? 'string.short' : field.valuetype );

				const validators = field.validators || [];
				if( validators.length > 0 )
					console.warn( `Found validators (${field.name}):`, JSON.stringify( validators ) );

				if( remainingFieldNames[f] )	// Just set type
				{
					//console.log( "UPDATING REMAINING FIELD:", field.name, validators.length );
					if( newType )
						this.$set( remainingFieldNames[f], 'type', newType );
					this.$set( remainingFieldNames[f], 'validators', validators );
					this.$set( remainingFieldNames[f], 'valuetypelocked', !!field.valuetype );
					this.$set( remainingFieldNames[f], 'allownull', field.allownull || false );
				}
				else
				{
					//console.log( "ADDING NEW FIELD:", field.name, validators.length );
					this.addSubItem( { fieldname : field.name, type : newType, validators, valuetypelocked : !!field.valuetype, allownull : ( field.allownull || false ), structured : ( field.required ? 'required' : 'optional' ), inactive : ( !field.required ? true : undefined ) } );
				}
			}
		},
		// When the item is optional, activate it.
		activateThisItem( )
		{
			if( !this.augment )	// Source mode
				this.$delete( this.item, 'inactive' );
			else	// Augment mode
			{
				this.augmenting = 'force';
				this.augItem;
			}
		},
		// Use the source/aug values to (re)set the internal cache value.
		setCachedValue( augmenting )	// Used for initialization and for when you switch augmentation mode..
		{
			augmenting = ( typeof augmenting !== 'undefined' ? augmenting : ( this.augmenting || false ) );
			
			// 1. Set necessary defaults to the internal cache value object:
			const newCachedValue = {	// Necessary Defaults:
				string : "",
				boolean : false,
				reference : { $ref : undefined, $source : "" },
				object_fields : [],
				array_values : []
			};
			
			// 2. Get the current aug, or empty object
			const aug = this.item.aug || { };

			if( aug.remove === true )
				return;	// Do nothing.

			// 3. Set the internal value type
			this.type = this.activeItem.type;
			
			// 4. Based on the type, set the appropriate internal cache value...
			if( this.type.startsWith( 'string' ) )
			{
				const value = ( this.augmenting && typeof aug.value !== 'undefined' ? aug.value : ( this.item.value || '' ) );
				newCachedValue.string = value;
			}
			else if( this.type === 'object' )
			{
				const value = ( this.augmenting ? ( aug.fields || [] ) : ( this.item.fields || [] ) );
				newCachedValue.object_fields = value;
			}
			else if( this.type === 'array' )
			{
				const value = ( this.augmenting ? ( aug.values || [] ) : ( this.item.values || [] ) );
				newCachedValue.array_values = value;
			}
			else if( this.type )
			{
				const value = ( this.augmenting && typeof aug.value !== 'undefined' ? aug.value : this.item.value );
				if( value !== undefined )
					newCachedValue[this.type] = value;
			}

			this.value = newCachedValue;
		},
		cycleAugmentingMode( )
		{
			if( this.augmenting === true )
				this.augmenting = ( typeof this.item.fieldname !== 'undefined' && this.item.structured !== 'required' ? 'hide' : false );
			else if( this.augmenting === false )
				this.augmenting = true;
			else if( this.augmenting === 'hide' )
			{
				if( this.item.aug && this.item.aug.lock === true )
					alert( "This field must remain hidden, because it violates the object schema." );
				else
					this.augmenting = false;
			}
		},
		updateItemValue( )
		{
			if( this.augment && this.augmenting !== true && this.augmenting !== 'force' )
			{
				if( this.augmenting === 'hide' )
					this.$set( this.augItem, "remove", true );
				else if( this.augmenting === false )	// TODO: So that we don't augment what is not augmented! Must adjust other functionality first.
				 	this.$delete( this.item, 'aug' );
				
				return;
			}

			const item = this.activeItem;	// this.augItem adds the aug : { <type> }
			const type = item.type || '';

			if( type === 'object' )
				this.$set( item, 'fields', this.value.object_fields || [] );
			else if( type === 'array' )
				this.$set( item, 'values', this.value.array_values || [] );
			else
			{
				// Clear object fields and array values in the source item.
				this.$delete( item, 'fields' );
				this.$delete( item, 'values' );

				if( type.startsWith( 'string' ) )
					this.$set( item, 'value', this.value.string );
				else if( type === 'number' && ( this.value.number === null || this.value.number === '' ) )
					this.$delete( item, 'value' );
				// Valid 'number' types get captured here...
				else if( typeof this.value[type] !== 'undefined' )
					this.$set( item, 'value', this.value[type] );
				else
					this.$delete( item, 'value' );
			}
		},
		getSchemaItem( )
		{
			if( this.type !== 'object' )
				this.$delete( this.activeItem, '$schema' );
			else if( !this.activeItem.$schema || typeof this.activeItem.$schema !== 'object' )
				this.$set( this.activeItem, '$schema', { type : "none" } );
			return this.activeItem.$schema;
		},
		getIdItem( )
		{
			if( this.type !== 'object' )
				this.$delete( this.activeItem, '$id' );
			else if( !this.activeItem.$id || typeof this.activeItem.$id !== 'object' )
				this.$set( this.activeItem, '$id', { type : "auto" } );
			return this.activeItem.$id;
		},
		getDateLocalISOString( value )
		{
			try {
				let month = value.getMonth( ) + 1;
				if( month < 10 ) month = "0"+ month;
				let day = value.getDate( );
				if( day < 10 ) day = "0"+ day;
				let hours = value.getHours( );
				if( hours < 10 ) hours = "0"+ hours;
				let minutes = value.getMinutes( );
				if( minutes < 10 ) minutes = "0"+ minutes;
				let seconds = value.getSeconds( );
				if( seconds < 10 ) seconds = "0"+ seconds;
				return value.getFullYear() +"-"+ month +"-"+ day +"T"+ hours +":"+ minutes +":"+ seconds;
			} catch( err ) { return ""; }
		},
		getValueTypeClass( valueType )
		{
			switch( valueType )
			{
				case 'array':
				case 'object':
				case 'reference':
				case 'string.block':
				case 'string.html':
					return 'col-12';
			}
			return "col";
		},
		removeThisItem( )
		{
			console.log( "Removing:", this.index, JSON.stringify( this.item ) );
			let itemCount = this.subItems.length;
			if( itemCount > 0 )
			{
				let message;
				if( this.activeItem.type === 'object' )
					message = "The object you are about to remove is not empty. The "+ itemCount +" contained field(s) will be removed as well. Continue?";
				else if( this.activeItem.type === 'array' )
					message = "The list (array) you are about to remove is not empty. The "+ itemCount +" contained value(s) will be removed as well. Continue?";
				if( !confirm( message ) )
					return;
			}
			if( this.item.structured == 'required' )
				return alert( "You cannot remove structured required fields. Please inform an administrator of this error." );
			else if( this.item.structured == 'optional' )
			{
				this.$set( this.item, 'inactive', true );
				if( this.augment )
					this.augmenting = false;
			}
			else
				this.$delete( this.source, this.index );
		},
		addSubItem( { fieldname = "", type = "string.short", valuetypelocked = false, inactive = undefined, structured = undefined, validators = [] } )
		{
			let htmlId = randomString( );
			if( this.type === 'object' )
			{
				if( !Array.isArray( this.value.object_fields ) )
					this.$set( this.value, "object_fields", [] );
				let newField;
				if( this.augment && this.augmenting === false )
				{
					//console.warn( "TODO: Not sure if in augmentations, [structured] should be on the [aug] or source field... Currently on [aug]" );
					let newType = "new";
					let newAug = { type, value : "" };
					if( structured === 'optional' )
					{
						newAug = undefined;
						newType = type;
					}
					else if( structured === 'required' )
						inactive = undefined;
					newField = { fieldname, type : newType, structured, inactive, _htmlId : htmlId, aug : newAug };
				}
				else
					newField = { fieldname, type, value : "", inactive, structured, _htmlId : htmlId };
				newField.valuetypelocked = valuetypelocked;
				newField.validators = validators;
				//console.log( "SETTING NEW FIELD:", newField.fieldname, newField.validators.length );
				this.$set( this.value.object_fields, this.value.object_fields.length, newField );
			}
			else if( this.type === 'array' )
			{
				if( !Array.isArray( this.value.array_values ) )
					this.$set( this.value, "array_values", [] );
				this.$set( this.value.array_values, this.value.array_values.length, { type, validators, valuetypelocked, value : "", _htmlId : htmlId } );
			}
			else
				throw new Error( "Trying to add a sub-item to an invalid editor item. Type must be either 'array' or 'object', not '"+ this.item.type +"'!" );
			this.$nextTick( function( ) {
				document.getElementById( htmlId ).focus( );
			} );
		},
	}
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/utilities/ObjectEditorItem.vue